
const dashboardHelpers = {
    getTranslated(n) {
        if (!n) {
            return this.$t('NO NAME');
        }
        if (document.documentElement.lang in n) {
          return n[document.documentElement.lang]
        } else {
          return n['en']
        }
      },
}

export default dashboardHelpers
